export const staffDashboard = {
  title: 'Staff Portal',
  subtitle: 'Staff Portal',
  settings: 'Settings',
  
  // Quick Actions
  quickActions: 'Quick Actions',
  scanForCheckout: 'Scan for checkout',
  menuItems: 'Menu items',
  editCustomer: 'Edit customer',
  scanReceipt: 'Scan receipt',
  viewTransactions: 'View transactions',
  
  // Customer Verification
  customerVerified: 'Customer Verified',
  welcomeBack: 'Welcome back',
  firstVisit: 'First Visit!',
  birthdayBonus: 'Birthday Bonus!',
  continueToCheckout: 'Continue to checkout',
  
  // Checkout
  checkout: 'Checkout',
  billAmount: 'Bill Amount',
  enterBillAmount: 'Enter the bill amount',
  billAmountPlaceholder: '0.00',
  availableBalance: 'Available Balance',
  redeemAmount: 'Redeem Amount',
  enterRedeemAmount: 'Enter amount to redeem',
  redeemAmountPlaceholder: '0.00',
  maxRedeemable: 'Max redeemable',
  summary: 'Summary',
  originalAmount: 'Original Amount',
  discount: 'Discount (5%)',
  vcRedeemed: 'VC Redeemed',
  finalAmount: 'Final Amount',
  processCheckout: 'Process checkout',
  processing: 'Processing...',
  
  // Transaction Success
  transactionSuccess: 'Transaction Successful!',
  transactionId: 'Transaction ID',
  customer: 'Customer',
  vcEarned: 'VC Earned',
  birthdayBonusEarned: 'Birthday Bonus',
  done: 'Done',
  
  // Customer Lookup
  lookupCustomer: 'Lookup Customer',
  searchByEmail: 'Search by email or name',
  search: 'Search',
  scanQR: 'Scan QR Code',
  noCustomerFound: 'No customer found',
  
  // Edit Customer
  editCustomerTitle: 'Edit Customer',
  fullName: 'Full Name',
  email: 'Email',
  birthday: 'Birthday',
  optional: 'Optional',
  saveChanges: 'Save changes',
  saving: 'Saving...',
  
  // QR Scanner
  scanCustomerQR: 'Scan customer QR',
  pointCamera: 'Point your camera at the customer\'s QR code',
  cancel: 'Cancel',
  
  // Receipt OCR
  scanReceiptTitle: 'Scan receipt',
  uploadReceipt: 'Upload receipt',
  takePhoto: 'Take photo',
  processingReceipt: 'Processing...',
  extracting: 'Extracting data from receipt...',
  
  // Menu Management
  menuManagement: 'Menu Management',
  items: 'items',
  available: 'available',
  import: 'Import',
  export: 'Export',
  add: 'Add',
  totalItems: 'Total Items',
  availableItems: 'Available',
  lowStock: 'Low Stock',
  categories: 'Categories',
  searchPlaceholder: 'Search by name or category...',
  allItems: 'All Items',
  meatPoultry: 'Meat & Poultry',
  seafood: 'Seafood',
  vegetables: 'Vegetables',
  processed: 'Processed',
  noodlesRice: 'Noodles & Rice',
  herbsSpices: 'Herbs & Spices',
  others: 'Others',
  bulkActions: 'Bulk Actions',
  selected: 'selected',
  delete: 'Delete',
  toggleAvailability: 'Toggle Availability',
  sortBy: 'Sort by',
  name: 'Name',
  price: 'Price',
  stock: 'Stock',
  category: 'Category',
  viewMode: 'View',
  list: 'List',
  grid: 'Grid',
  noItems: 'No menu items found',
  noItemsDesc: 'Start by adding your first menu item or importing from CSV',
  
  // Menu Item Form
  addMenuItem: 'Add menu item',
  editMenuItem: 'Edit menu item',
  itemName: 'Item name',
  required: 'Required',
  itemNamePlaceholder: 'e.g., Chicken Breast, Tiger Prawns',
  itemNameHint: 'Use the exact name as it appears on receipts for better OCR matching',
  priceRM: 'Price (RM)',
  unit: 'Unit',
  unitPlaceholder: 'Kg, Pack, Box',
  nutritionalInfo: 'Nutritional Info (per 100g)',
  calories: 'Calories',
  protein: 'Protein (g)',
  fat: 'Fat (g)',
  inventory: 'Inventory',
  stockQuantity: 'Stock Quantity',
  lowStockAlert: 'Low Stock Alert',
  availableForSale: 'Available for Sale',
  toggleUnavailable: 'Toggle to mark item as unavailable',
  notes: 'Notes',
  notesPlaceholder: 'Additional notes or descriptions...',
  addItem: 'Add item',
  updateItem: 'Update item',
  
  // Menu Item Import
  importMenuItems: 'Import menu items',
  howToImport: 'How to import',
  importStep1: 'Download the CSV template below (includes format instructions and examples)',
  importStep2: 'Fill in your menu items - name and category are required',
  importStep3: 'Keep the instruction row (starts with #) for reference - it will be ignored during import',
  importStep4: 'Upload the completed CSV file',
  importStep5: 'Review any validation errors and fix them',
  importStep6: 'Click Import to add items to your menu',
  csvFormatPreview: 'CSV Format Preview:',
  formatLine1: 'First row: Column headers (required)',
  formatLine2: 'Second row: Instructions (optional, will be skipped)',
  formatLine3: 'Following rows: Your menu items',
  downloadTemplate: 'Download CSV template',
  uploadCSV: 'Upload CSV file',
  clickToUpload: 'Click to upload CSV file',
  maxFileSize: 'Maximum file size: 5MB',
  validationErrors: 'Validation Errors',
  importComplete: 'Import Complete',
  successfullyImported: 'Successfully imported',
  failed: 'Failed',
  totalProcessed: 'Total processed',
  validCategories: 'Valid Categories:',
  importItems: 'Import items',
  
  // Transactions Page
  transactions: 'Transactions',
  transaction: 'transaction',
  period: 'Period',
  oneDay: '1 Day',
  sevenDays: '7 Days',
  thirtyDays: '30 Days',
  all: 'All',
  date: 'Date',
  amount: 'Amount',
  noTransactions: 'No transactions found for the selected period',
  totalAmount: 'Total Amount',
  
  // Settings
  profile: 'Profile',
  memberSince: 'Member since',
  preferences: 'Preferences',
  language: 'Language',
  notifications: 'Notifications',
  about: 'About',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  appVersion: 'App Version',
  logout: 'Sign out',
  
  // Toast Messages
  customerNotFound: 'Customer not found. Please check the QR code and try again.',
  transactionFailed: 'Failed to process transaction',
  customerUpdated: 'Customer details updated successfully!',
  receiptScanned: 'Receipt scanned!',
  itemsMatched: 'items matched',
  confidence: 'Confidence',
  
  ocr: {
    linkSuccess: 'Receipt linked to {customer}\'s transaction! ({timeDiff} difference) | {items} items | Confidence: {confidence}%',
    scanSuccess: 'Receipt scanned! Amount: RM {amount}{itemsText} | Confidence: {confidence}% | ⚠️ No matching transaction found - create transaction first',
    linkError: 'Receipt scanned but failed to link: {error}',
    refreshError: 'Failed to refresh customer data',
  },

  noItemsToExport: 'No items to export',
  exportedItems: 'Exported',
  exportFailed: 'Failed to export items. Please try again.',
  menuItemAdded: 'Menu item added successfully',
  menuItemUpdated: 'Menu item updated successfully',
  failedToSave: 'Failed to save item',
  
  // Error Messages
  error: 'Error',
  tryAgain: 'Please try again',
  loadingError: 'Failed to load data',
  noRestaurant: 'No restaurant assigned to your account',
  
  // Transaction Detail Sheet
  detailSheetTitle: 'Transaction Details',
  detailCustomer: 'Customer',
  detailBreakdown: 'Breakdown',
  detailReceiptItems: 'Receipt Items',
  detailNoItems: 'No items extracted',
  detailFirstVisit: 'First Visit',
  detailReceiptScanned: 'Receipt Scanned',
  detailVoided: 'Voided',
  voidTransaction: 'Void Transaction',
  voidReason: 'Reason for voiding',
  voidReasonPlaceholder: 'e.g., Wrong amount entered',
  confirmVoid: 'Confirm Void',
  cancelVoid: 'Cancel',
  voidConfirmTitle: 'Void Transaction?',
  voidConfirmDesc: 'This action cannot be undone. The transaction amount will be deducted from revenue and points will be reversed.',
  voidSuccess: 'Transaction voided successfully',
};
